export default {"src":"/_next/static/media/llm-home.96fe5f1d.svg","height":768,"width":1366,"blurWidth":0,"blurHeight":0};